import { ActivityIndicator, Dimensions, Image, Modal, PixelRatio, ScrollView, StyleSheet, Text, TextInput, TouchableOpacity, View } from 'react-native'
import React, { useEffect, useState } from 'react'
import SuccessAlertComp from '../../alertComp/SuccessAlertComp'
import ErrorAlertComp from '../../alertComp/ErrorAlertComp'
import UseCreditsScreen from '../useCredits/UseCreditsScreen'
import Colours from '../../utils/Colours'
import TopHeaderComponent from '../aTopHeader/TopHeaderComponent'
import Toast from 'react-native-toast-message'
import toastConfig from '../../toasts/toastConfig'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import TransactionDigitCodeScreen from '../transactionDigitCode/TransactionDigitCodeScreen'
import AppTextInput from '../../utils/ColourThemes/AppTextInput'

const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const CreateMeezaTransferTo = ({ photo, firstname, lastname, username, hideModal }) => {

    const [isCommentBoxClicked, setIsCommentBoxClicked] = useState(false)
    const [doingsAmount, setDoingsAmount] = useState('')
    const [comments, setComments] = useState('')

    // const [showTablesToUseScreen, setShowTablesToUseScreen] = useState(false)
    const [showUseCreditScreen, setShowUseCreditScreen] = useState(false)


    const [isCreateCelebratoryClicked, setIsCreateCelebratoryClicked] = useState(false)


    const [isLoading, setIsLoading] = useState(false)

    const [isErrorCompVisible, setIsErrorCompVisible] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')
    const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false)
    const [transactCodeCorrect, setTransactCodeCorrect] = useState(false)
    const [showTransactionDigitCodeScreen, setShowTransactionDigitCodeScreen] = useState(false)

    useEffect(() => {
        //console.log('transactCodeCorrect', transactCodeCorrect)
        if (transactCodeCorrect) {
            handleTransferFundsToUser()
        }
    }, [transactCodeCorrect])

    const axiosPrivate = useAxiosPrivate()

    const handleCommentsForm = (text) => {
        //console.log(text)
        setComments(text)
    }

    const handleEnterTransferAmount = () => {
        setShowUseCreditScreen(true)
    }

    const handleTransactionCode = () => {
        if (!doingsAmount || doingsAmount.trim() === '') {
            // doingsAmount is empty or only spaces
            //console.warn("Doings amount is required");
            return;
        }
        setShowTransactionDigitCodeScreen(true)
    }
    const handleTransferFundsToUser = async () => {


        try {
            setIsLoading(true)
            const response = await axiosPrivate.post('/platformUserTransfers/platformUserTransfers', { username, transferAmt: doingsAmount, comments }
            )
            if (response.status === 200 || response.status === 201) {
                // //console.log('DONE:', response.data?.data)
                setTransactCodeCorrect(false)
                setSuccessMessage(response.data.message)
                setIsSuccessCompVisible(true)
            } else {
                //console.error('Unexpected response:', response.data);
                setTransactCodeCorrect(false)
                setErrorMessage('Unexpected response')
                setIsErrorCompVisible(true)
            }
        } catch (error) {

            if (error.response) {
                //console.error('Error response from server:', error.response.data);
                setTransactCodeCorrect(false)
                const errorMessages = error.response.data?.error || error.response.data?.message || 'Something went wrong';
                setErrorMessage(errorMessages);
                setIsErrorCompVisible(true);

            }
            else if (error.request) {
                //console.error('No response received:', error.request);
                setTransactCodeCorrect(false)
                setErrorMessage('No response Recieved check your internet')
                setIsErrorCompVisible(true)
            }
            else {
                //console.error('Error setting up the request:', error.message);
                setTransactCodeCorrect(false)
                setErrorMessage(error.message || 'Unexpected error occurred')
                setIsErrorCompVisible(true)
            }

        } finally {
            setIsLoading(false);
        }

    }

    if (isLoading) {
        return (
            <View style={styles.loaderContainer}>
                <ActivityIndicator size="large" color={Colours.PRIMARY} />
            </View>
        );
    }


    return (
        <View>
            <TopHeaderComponent headerText={'Create Meeza Transfer'} hideScreen={hideModal} />
            <ScrollView
                style={styles.componentStyle}
                contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
                showsVerticalScrollIndicator={false}
            >
                <View style={styles.celebratoryPullContainer}>
                    <View style={styles.JoinedNumber}>
                        <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <Text style={styles.doingsTxt} >TRANSFER TO</Text>
                            <Text style={styles.celebratoryTxt}> | {username} </Text>
                        </View>

                        {photo ? (
                            <Image source={{ uri: photo }} style={styles.userImage} />
                        ) : (
                            <Image source={require('../../../assets/profile_image_holder.jpg')} style={styles.userImage} />
                        )}

                    </View>
                    <View style={styles.searchBoxContainer}>
                        {/* <View style={styles.SearchBox}> */}

                        <View style={styles.transferNameStyle}>
                            <Text style={styles.celebratoryTxt}>{firstname} {lastname} </Text>

                        </View>



                        <View style={styles.celebratoryPullContainer2}>
                            <View style={styles.tablevalueContainer}>
                                <Text style={styles.doingsAmtTxt} >TRANSFER AMOUNT: </Text>
                                <Text style={styles.ngnTxt} >NGN {doingsAmount ? doingsAmount : '0.00'} </Text>
                            </View>
                            <TouchableOpacity style={styles.tableValueButton}
                                onPress={handleEnterTransferAmount}
                            >
                                <Text style={styles.openCreatTxt} >Open</Text>

                            </TouchableOpacity>
                        </View>
                        {/* </View> */}
                        <AppTextInput
                            style={[styles.commentBox, isCommentBoxClicked && styles.focusedBorder,
                                //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                            ]}
                            placeholder="Drop a comment:"
                            numberOfLines={3}
                            multiline
                            onFocus={() => setIsCommentBoxClicked(true)}
                            onBlur={() => setIsCommentBoxClicked(false)}
                            // value={tableCaption}
                            onChangeText={handleCommentsForm}
                        />

                        <TouchableOpacity style={[styles.tableValueButton2, {

                            backgroundColor: isCreateCelebratoryClicked ? Colours.PRIMARY : Colours.DARKGRAY

                        }]}
                            // onPress={handleTransferFundsToUser}
                            onPress={handleTransactionCode}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <ActivityIndicator size="small" color="white" />
                            ) : (
                                <Text style={styles.openCreatTxt}>
                                    Transfer
                                </Text>
                            )}
                        </TouchableOpacity>

                    </View>

                </View>


            </ScrollView>
            <Modal
                animationType='fade'
                visible={showUseCreditScreen}>
                <View style={{ backgroundColor: Colours.LIGHTEST }}>
                    <UseCreditsScreen
                        // setShowUseCreditScreen={setShowUseCreditScreen}
                        hideScreen={() => setShowUseCreditScreen(false)}
                        userName={username}
                        doingsAmount={doingsAmount}
                        setDoingsAmount={setDoingsAmount}
                        meezaTransfers={true}
                    />
                </View>

            </Modal>

            <Modal
                visible={isErrorCompVisible}
                transparent={true}
                animationType="fade"
            >
                <ErrorAlertComp
                    message={errorMessage}
                    onClose={() => setIsErrorCompVisible(false)}
                />
            </Modal>

            <Modal
                visible={isSuccessCompVisible}
                transparent={true}
                animationType="fade"
            >
                <SuccessAlertComp
                    message={successMessage}
                    onClose={() => {
                        setIsSuccessCompVisible(false)
                        hideModal()
                    }}
                />
            </Modal>
            {/* 
            <Modal
                visible={isTransactionDigitCodeVisible}
                animationType="fade"
            >
                <TopHeaderComponent headerText={'Enter Transaction Code'} hideScreen={() => setIsTransactionDigitCodeVisible(false)} />
                <ScrollView
                    contentContainerStyle={{ flexGrow: 1, paddingBottom: 100, backgroundColor: Colours.LIGHTEST }}
                >
                    <TransactionDigitCodeScreen
                        hideScreen={() => {
                            setIsTransactionDigitCodeVisible(false)
                            handleTransferFundsToUser()
                        }}
                    />
                </ScrollView>
            </Modal> */}
            <Modal
                animationType='fade'
                visible={showTransactionDigitCodeScreen}
                onRequestClose={() => setShowTransactionDigitCodeScreen(false)}
            >
                <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: Colours.LIGHTEST }}>
                    <TransactionDigitCodeScreen
                        hideScreen={() => setShowTransactionDigitCodeScreen(false)}
                        setTransactCodeCorrect={() => setTransactCodeCorrect(true)}
                        doingsAmount={doingsAmount}
                    />
                </View>

            </Modal>

            <Toast config={toastConfig} />
        </View>
    )
}

const styles = StyleSheet.create({
    componentStyle: {
        backgroundColor: Colours.LIGHTEST,
        height: '100%',
    },
    loaderContainer: {
        flex: 1,
        marginTop: dynamicSpacing(10),
        backgroundColor: '#fff', // optional
    },
    doingsTxt: {
        marginTop: dynamicSpacing(10),
        marginBottom: dynamicSpacing(10),
        fontSize: dynamicFontSize(15),
        color: Colours.DARKLIGHTGRAY,
        fontFamily: 'Sen-Bold',
    },
    celebratoryTxt: {
        paddingLeft: dynamicSpacing(1),
        paddingBottom: dynamicSpacing(0),
        color: Colours.PRIMARY,
        fontFamily: 'Sen-Regular',
    },
    photoTxt: {
        color: Colours.DARKLIGHTGRAY,
        fontSize: dynamicFontSize(15),
        fontFamily: 'Sen-Regular',
    },
    imageStyle: {
        width: dynamicSize(45),
        height: dynamicSize(40),
        borderRadius: dynamicSize(10),
    },
    doingsAmtTxt: {
        fontSize: dynamicFontSize(10),
        color: Colours.DARKLIGHTGRAY,
        fontFamily: 'Sen-Bold',
    },
    ngnTxt: {
        fontSize: dynamicFontSize(17),
        color: Colours.DARKGRAY,
        fontFamily: 'Sen-Bold',
    },
    openCreatTxt: {
        fontSize: dynamicFontSize(15),
        color: 'white',
        fontFamily: 'Sen-Bold',
    },
    celebratoryPullContainer: {
        display: 'flex',
        margin: dynamicSpacing(15),
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(15),
        backgroundColor: 'white',
        shadowColor: '#E8E8E8',
    },
    celebratoryPullContainer2: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: dynamicSize(70),
        width: "100%",
        //  margin: dynamicSpacing(15),
        marginTop: dynamicSpacing(15),
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(10),
        backgroundColor: Colours.PRIMARY_LIGHTER,
        shadowColor: '#E8E8E8',
    },
    JoinedNumber: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: dynamicSpacing(1),
    },
    photoViewStyle: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: dynamicSize(50),
        width: '100%',
        marginTop: dynamicSpacing(10),
        padding: dynamicSpacing(10),
        borderWidth: dynamicSize(2),
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(10),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(15),
        marginBottom: dynamicSpacing(5),
        backgroundColor: Colours.LIGHTGRAY,
    },
    inputTxt: {
        height: dynamicSize(40),
        width: '100%',
        marginTop: dynamicSpacing(10),
        padding: dynamicSpacing(10),
        borderWidth: dynamicSize(2),
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(10),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(15),
        backgroundColor: Colours.LIGHTGRAY,
        marginBottom: dynamicSpacing(5),
    },
    commentBox: {
        height: dynamicSize(50),
        width: '100%',
        marginTop: dynamicSpacing(15),
        marginBottom: dynamicSpacing(30),
        padding: dynamicSpacing(10),
        borderWidth: dynamicSize(2),
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(10),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(15),
        backgroundColor: Colours.LIGHTGRAY,
        marginBottom: dynamicSpacing(5),
    },
    tableValueButton: {
        display: 'flex',
        borderRadius: dynamicSize(10),
        justifyContent: 'center',
        alignItems: 'center',
        height: dynamicSize(40),
        width: dynamicSize(100),
        backgroundColor: Colours.PRIMARY,
    },
    tableValueButton2: {
        display: 'flex',
        borderRadius: dynamicSize(10),
        justifyContent: 'center',
        marginTop: dynamicSpacing(10),
        alignItems: 'center',
        height: dynamicSize(55),
        width: '100%',
        backgroundColor: Colours.DARKGRAY,
    },
    searchBoxContainer: {
        display: 'flex',
        // alignItems: 'center',
    },
    focusedBorder: {
        borderColor: Colours.PRIMARY,
    },
    userImage: {
        width: dynamicSize(45),
        height: dynamicSize(45),
        borderRadius: 99,
    },
    transferNameStyle: {
        //flex: 1,
        display: 'flex',
        //  flexDirection: 'row',
        // flexWrap: 'wrap',
        //  justifyContent: 'center',
        marginTop: dynamicSpacing(20),
        padding: dynamicSpacing(10),
        borderWidth: dynamicSize(3),
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(10),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(17),
        backgroundColor: Colours.LIGHTGRAY,
    },
    profileContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: dynamicSpacing(10),
        gap: dynamicSpacing(10),
    },
});

export default CreateMeezaTransferTo

